// src/api/cotizacion.js
import { apiFetch } from './index.js';

const API_BASE = '/api/Cotizacion';

/**
 * Obtener todas las cotizaciones
 */
export const obtenerCotizaciones = async () => {
  try {
    const response = await apiFetch(API_BASE);
    return { success: true, data: response };
  } catch (error) {
    console.error('Error al obtener cotizaciones:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Obtener cotización por ID
 */
export const obtenerCotizacionPorId = async (id) => {
  try {
    const response = await apiFetch(`${API_BASE}/${id}`);
    return { success: true, data: response };
  } catch (error) {
    console.error(`Error al obtener cotización ID ${id}:`, error);
    return { success: false, error: error.message };
  }
};

/**
 * Crear nueva cotización
 */
export const crearCotizacion = async (data) => {
  try {
    const response = await apiFetch(API_BASE, {
      method: 'POST',
      body: JSON.stringify(data)
    });
    return { success: true, data: response };
  } catch (error) {
    console.error('Error al crear cotización:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Actualizar cotización
 */
export const actualizarCotizacion = async (data) => {
  try {
    const response = await apiFetch(API_BASE, {
      method: 'PUT',
      body: JSON.stringify(data)
    });
    return { success: true, data: response };
  } catch (error) {
    console.error('Error al actualizar cotización:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Eliminar cotización
 */
export const eliminarCotizacion = async (id) => {
  try {
    const response = await apiFetch(`${API_BASE}/${id}`, {
      method: 'DELETE'
    });
    return { success: true, data: response };
  } catch (error) {
    console.error(`Error al eliminar cotización ID ${id}:`, error);
    return { success: false, error: error.message };
  }
};

/**
 * Enviar cotización al cliente
 */
export const enviarCotizacion = async (id) => {
  try {
    const response = await apiFetch(`${API_BASE}/${id}/enviar`, {
      method: 'POST'
    });
    return { success: true, data: response };
  } catch (error) {
    console.error(`Error al enviar cotización ID ${id}:`, error);
    return { success: false, error: error.message };
  }
};

/**
 * Aprobar cotización
 */
export const aprobarCotizacion = async (id) => {
  try {
    const response = await apiFetch(`${API_BASE}/${id}/aprobar`, {
      method: 'POST'
    });
    return { success: true, data: response };
  } catch (error) {
    console.error(`Error al aprobar cotización ID ${id}:`, error);
    return { success: false, error: error.message };
  }
};

/**
 * Rechazar cotización
 */
export const rechazarCotizacion = async (id, motivo = null) => {
  try {
    const response = await apiFetch(`${API_BASE}/${id}/rechazar`, {
      method: 'POST',
      body: JSON.stringify(motivo)
    });
    return { success: true, data: response };
  } catch (error) {
    console.error(`Error al rechazar cotización ID ${id}:`, error);
    return { success: false, error: error.message };
  }
};

/**
 * Obtener cotizaciones por cliente
 */
export const obtenerCotizacionesPorCliente = async (idCliente) => {
  try {
    const response = await apiFetch(`${API_BASE}/cliente/${idCliente}`);
    return { success: true, data: response };
  } catch (error) {
    console.error(`Error al obtener cotizaciones del cliente ${idCliente}:`, error);
    return { success: false, error: error.message };
  }
};

/**
 * Obtener cotizaciones por estado
 */
export const obtenerCotizacionesPorEstado = async (estado) => {
  try {
    const response = await apiFetch(`${API_BASE}/estado/${estado}`);
    return { success: true, data: response };
  } catch (error) {
    console.error(`Error al obtener cotizaciones por estado ${estado}:`, error);
    return { success: false, error: error.message };
  }
};

/**
 * Obtener cotizaciones por rango de fechas
 */
export const obtenerCotizacionesPorFechas = async (inicio, fin) => {
  try {
    const response = await apiFetch(`${API_BASE}/fechas?inicio=${inicio}&fin=${fin}`);
    return { success: true, data: response };
  } catch (error) {
    console.error('Error al obtener cotizaciones por fechas:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Obtener cotizaciones por usuario
 */
export const obtenerCotizacionesPorUsuario = async (idUsuario) => {
  try {
    const response = await apiFetch(`${API_BASE}/usuario/${idUsuario}`);
    return { success: true, data: response };
  } catch (error) {
    console.error(`Error al obtener cotizaciones del usuario ${idUsuario}:`, error);
    return { success: false, error: error.message };
  }
};

/**
 * Convertir cotización a Venta
 */
export const convertirCotizacionAVenta = async (id, idVendedor = null) => {
  try {
    const url = idVendedor ? `${API_BASE}/${id}/convertir-venta?idVendedor=${idVendedor}` : `${API_BASE}/${id}/convertir-venta`;
    const response = await apiFetch(url, { method: 'POST' });
    return { success: true, data: response };
  } catch (error) {
    console.error(`Error al convertir cotización ${id} a venta:`, error);
    return { success: false, error: error.message };
  }
};

/**
 * Convertir cotización a Reparación
 */
export const convertirCotizacionAReparacion = async (id, idTecnico = null) => {
  try {
    const url = idTecnico ? `${API_BASE}/${id}/convertir-reparacion?idTecnico=${idTecnico}` : `${API_BASE}/${id}/convertir-reparacion`;
    const response = await apiFetch(url, { method: 'POST' });
    return { success: true, data: response };
  } catch (error) {
    console.error(`Error al convertir cotización ${id} a reparación:`, error);
    return { success: false, error: error.message };
  }
};

/**
 * Convertir cotización a Venta y Reparación
 */
export const convertirCotizacionAambos = async (id, idVendedor = null, idTecnico = null) => {
  try {
    let url = `${API_BASE}/${id}/convertir-ambos`;
    const params = [];
    if (idVendedor) params.push(`idVendedor=${idVendedor}`);
    if (idTecnico) params.push(`idTecnico=${idTecnico}`);
    if (params.length) url += `?${params.join('&')}`;
    
    const response = await apiFetch(url, { method: 'POST' });
    return { success: true, data: response };
  } catch (error) {
    console.error(`Error al convertir cotización ${id} a ambos:`, error);
    return { success: false, error: error.message };
  }
};

/**
 * Obtener historial de cotización
 */
export const obtenerHistorialCotizacion = async (id) => {
  try {
    const response = await apiFetch(`${API_BASE}/${id}/historial`);
    return { success: true, data: response };
  } catch (error) {
    console.error(`Error al obtener historial de cotización ${id}:`, error);
    return { success: false, error: error.message };
  }
};